import useSWR from "swr";
import {
  buildCompletionManagementUrl,
  fetchCompletionManagement,
} from "../services/completionManagement";
import { ProgressNode } from "../types";

export const useCompletionManagement = (
  corporateId: string | number | undefined,
  userId: string | number | undefined,
  node: ProgressNode | null,
) => {
  const url =
    node && corporateId !== undefined && userId !== undefined
      ? buildCompletionManagementUrl(corporateId, userId, node)
      : null;

  const { data, isLoading, isValidating } = useSWR(
    url,
    fetchCompletionManagement,
    { onError: () => null, dedupingInterval: 0 },
  );

  return {
    management: data ?? null,
    isLoading: !!url && (isLoading || isValidating),
  };
};
